export default "/assets/site/images/map-marker.png?05ecefbb2666bd5c8c417623dc2e0a6d";